<template>
  <div class="section-cta">
    <div class="cta-container">
      <h2 class="cta-heading">{{ displayData.heading }}</h2>
      <p class="cta-subheading">{{ displayData.subheading }}</p>

      <!-- 문의 폼 미리보기 -->
      <div class="cta-form-preview">
        <div class="form-row">
          <div class="form-field">
            <label>담당자명</label>
            <div class="form-input-placeholder" />
          </div>
          <div class="form-field">
            <label>연락처</label>
            <div class="form-input-placeholder" />
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <label>이메일</label>
            <div class="form-input-placeholder" />
          </div>
        </div>
        <div class="form-row">
          <div class="form-field full">
            <label>문의내용</label>
            <div class="form-textarea-placeholder" />
          </div>
        </div>
        <div class="form-submit">
          <div class="submit-button-preview">전송</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_DATA = {
  heading: '서티라이프와 함께하세요',
  subheading: '도입 문의 및 데모 신청을 남겨주시면 담당자가 연락드리겠습니다.',
  formEmail: '',
};

export default {
  name: 'SectionCTA',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    displayData() {
      return { ...DEFAULT_DATA, ...this.data };
    },
  },
};
</script>

<style scoped>
.section-cta {
  background: #141c26;
  padding: 48px 24px 60px;
}

.cta-container {
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
}

.cta-heading {
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
}

.cta-subheading {
  color: rgba(255, 255, 255, 0.7);
  font-size: 15px;
  margin-bottom: 32px;
}

.cta-form-preview {
  text-align: left;
}

.form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.form-field {
  flex: 1;
}

.form-field.full {
  width: 100%;
}

.form-field label {
  display: block;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  margin-bottom: 6px;
}

.form-input-placeholder {
  height: 36px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 6px;
}

.form-textarea-placeholder {
  height: 80px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 6px;
}

.form-submit {
  text-align: center;
  margin-top: 20px;
}

.submit-button-preview {
  display: inline-block;
  background: #1677ff;
  color: #fff;
  padding: 10px 48px;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
}
</style>
